import React from "react";

import * as Api from 'api/api';
// import * as UsersApi from 'api/users';
import { ApiUser } from "api/users";


import PageContents from "components/PageContents";

import { Box, Button, Dialog, DialogTitle, List, ListItem, ListItemAvatar, ListItemText, Stack, Typography } from "@mui/material";
import PageDialog from "../../../tsui/PageDialog";

import * as F from 'tsui/Form';


// export interface SimpleDialogProps {
//     open: boolean;
//     selectedValue: string;
//     onClose: (value: string) => void;
//   }

interface UserDetailsTabProps {
    userId: string;
    onClose: () => void;
    userCards: Array<string>;
    open: boolean;
    selectedValue: string;
}


export default function UserCardsCollection(props: UserDetailsTabProps) {

  const form = F.useForm({ type: 'input' });


    // const { onClose, selectedValue, open } = props;

    // const handleClose = () => {
    //   onClose(selectedValue);
    // };
  
    // const handleListItemClick = (value: string) => {
    //   onClose(value);
    // };

        let userCards = props.userCards

  
    return (

      <PageDialog type='confirm' title='User Cards Collection' form={form} size='sm' onClose={props.onClose}>
        <Box sx={{ display: 'block', marginTop: 2}}>
          {userCards.map((cards, index) =>
                 <Box key={index} sx={{ display: 'grid' }}>
                    <Typography sx={{ color: '#dd8b00', fontSize: 'larger', marginLeft: 1 }}>{cards}</Typography>
                 </Box>
          )}
          </Box>   
      </PageDialog>
        // <Dialog onClose={props.onClose} open={props.open} PaperProps={{ sx: { width: 500, height: 300, borderRadius: 5, border: 1.5, borderColor: '#29b6f6' } }}>
        //   <DialogTitle sx={{textAlign: 'center'}}>User Cards Collection</DialogTitle>
        //     <Box sx={{width: '100%', height: 1.5, backgroundColor: 'gray'}} />
        //   <Box sx={{ display: 'block', marginTop: 2}}>

        //     {userCards.map((cards, index) =>
        //          <Box key={index} sx={{ display: 'grid' }}>
        //             <Typography sx={{ color: '#dd8b00', fontSize: 'larger', marginLeft: 1 }}>{cards}</Typography>
        //          </Box>
        //   )}

        //  </Box>           
        // </Dialog>
      );
  }

// interface UserDetailsTabProps {
//     userId: string;
//     onClose: () => void;
//     userCards: Array<string>;
// }

// export default function UserCardsCollection(props: UserDetailsTabProps) {
//     // const mounted = React.useRef(false);
//     // const [dataRequested, setDataRequested] = React.useState(false);
//     const [errorMessage, setErrorMessage] = React.useState(null);
//     const [userCardsCollection, setUserCardsCollection] = React.useState(false);
//     // const [userData, setUserData] = React.useState<UsersApi.ApiUser | null>(null);
//     const [data, setData] = React.useState<ApiUser | null>(null);
//     const form = F.useUpdateForm();


//     let userCards = props.userCards

//     const onSubmit = React.useCallback((evt: F.InputFormEvent) => {
//         evt.data.userId = props.userId

//         // Api.requestSession<any>('admin', 'update_user', evt.data).then(d => {
//         Api.requestSession<any>('admin', 'update_user', evt.data).then(d => {

//             props.onClose();
//             // console.log(`modified count is ${d.modifiedCount}`)
//         }).catch(err => console.log(err));


//     }, []);


//     console.log('props.userId', props.userId)
//     console.log('props.userCards', props.userCards)

//     return <F.PageFormDialog title='User Cards Collection' form={form} size='sm' onSubmit={onSubmit} onClose={props.onClose}>

//         <Box sx={{ display: 'block', width: 1800 }}>

//             {userCards.map((cards, index) =>
//                 <Box key={index} sx={{ display: 'grid' }}>
//                     <Typography sx={{ color: '#dd8b00', fontSize: 'larger' }}>{cards}</Typography>
//                 </Box>
//             )}

//         </Box>




//     </F.PageFormDialog>

//     // return (
//     //     <Dialog onClose={props.onClose} open={}>
//     //       <DialogTitle>Set backup account</DialogTitle>
//     //       <List sx={{ pt: 0 }}>
//     //         {userCards.map((cards) => (
                
//     //             <ListItemText primary={cards} />

//     //         ))}
           
//     //       </List>
//     //     </Dialog>
//     //   );


// }

